import React from 'react';
import { EyeOff, X, ChevronRight, Loader2 } from 'lucide-react';

export const DomainMasqueradeModal = ({ users, masquerading, onSelect, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
    <div className="bg-[#0D1526] border border-white/10 rounded-2xl w-full max-w-md shadow-2xl">
      <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
        <div>
          <h2 className="text-white font-semibold flex items-center gap-2">
            <EyeOff className="w-4 h-4 text-amber-400" />
            View Portal as User
          </h2>
          <p className="text-white/40 text-xs mt-0.5">
            Select a user to masquerade as — you'll see the portal through their eyes
          </p>
        </div>
        <button onClick={onClose} className="text-white/30 hover:text-white transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="p-4 space-y-2 max-h-80 overflow-y-auto">
        {users.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-6">
            No portal users yet. Add users in the Users tab first.
          </p>
        ) : users.map(u => (
          <button
            key={u.id}
            onClick={() => onSelect(u)}
            disabled={masquerading}
            className="w-full flex items-center gap-3 p-3 bg-white/5 hover:bg-amber-500/10 border border-white/10 hover:border-amber-500/30 rounded-xl transition-all text-left group"
            data-testid={`masquerade-user-${u.id}`}
          >
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center text-white text-sm font-bold shrink-0">
              {u.name?.charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{u.name}</p>
              <p className="text-white/40 text-xs font-mono truncate">{u.email}</p>
            </div>
            <span className="text-xs px-2 py-0.5 rounded-full bg-white/10 text-white/40 shrink-0">
              {u.role?.replace('domain_', '')}
            </span>
            {masquerading
              ? <Loader2 className="w-4 h-4 text-amber-400 animate-spin shrink-0" />
              : <ChevronRight className="w-4 h-4 text-white/20 group-hover:text-amber-400 transition-colors shrink-0" />}
          </button>
        ))}
      </div>
    </div>
  </div>
);
